import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

type ReportKpiTileProps = {
  label: string;
  value: string;
  hint?: string;
  flagged?: boolean;
  critical?: boolean;
  labelAside?: ReactNode;
  children?: ReactNode;
  className?: string;
};

export function ReportKpiTile({
  label,
  value,
  hint,
  flagged,
  critical,
  labelAside,
  children,
  className,
}: ReportKpiTileProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-[#E7E8EA] bg-white p-4',
        flagged && 'border-[#F0C98A] bg-[#FFFCF5]',
        critical && 'border-[#E5A6A1] bg-[#FDF5F4]',
        className
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs font-medium text-neutral-500">{label}</div>
        {labelAside}
      </div>
      <div className="mt-1 text-2xl font-semibold text-neutral-900">{value}</div>
      {hint ? <div className="mt-1 text-xs text-neutral-500">{hint}</div> : null}
      {children}
    </div>
  );
}
